import React from 'react';
import KickImage from 'Reuseables/KickImage';
import {
  Container,
  Row,
  Col
} from 'reactstrap';
import Countdown from 'react-countdown-now';
import moment from 'moment';

class SneakerRelease extends React.Component {
  constructor(props) {
    super(props) 
    this.state = {}
    this.rendered = this.rendered.bind(this);
  }
  checkDiff() {
    const { release_date } = this.props;

    let releaseDate = release_date === null ? moment() : release_date;
    let dateNow = moment();
    let date7 =  moment(releaseDate, "YYYYMMDD HH:mm:ss");
    let diff = date7.diff(dateNow);

    return diff;
  }

  rendered(data){
    const jam = parseInt(data.hours);
    const restDay = Math.round(jam / 24);
    if (data.completed) {
      // Render a completed state
      return (
        <p style={{ color: '#ff7a24' }}>
          {this.props.outOfStockLabel ? '' : 'RELEASED'}
        </p>
      );
    } else {
      // Render a countdown
      if (jam > 24) {
        return (
          <p style={{ color: '#ff7a24' }}>
            RELEASING IN { restDay+1 } DAYS
          </p>
        )
      } else if (jam > 0) {
        return (
          <p style={{ color: '#ff7a24' }}>
            RELEASING IN {data.hours}:{data.minutes}:{data.seconds}
          </p>
        )  
      } 
    }
  }

  render() {
    return (
      <Container>
        <Row>
          <Col style={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center'
          }}>
          {
            <Countdown
              date={Date.now() + this.checkDiff()}
              precision={3}
              daysInHours={true}
              renderer={this.rendered}
              onComplete={this._onTick}
            />
          }
          </Col>
        </Row>
      </Container>
    )
  }
}

export default SneakerRelease;
